module.exports = __webpack_public_path__ + "img/404_page_cover.69deada1.jpg";